import {
    SSO_LOGIN
} from "./type";

const initialState = {
    ssoLoginDetail: []
};

const LoginReducerSSO = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case SSO_LOGIN:
            return {
                ...state,
                ssoLoginDetail: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default LoginReducerSSO;
